import { render } from "./ChangeLanguage.vue?vue&type=template&id=7a9ee883&scoped=true"
import script from "./ChangeLanguage.vue?vue&type=script&lang=js"
export * from "./ChangeLanguage.vue?vue&type=script&lang=js"

import "./ChangeLanguage.vue?vue&type=style&index=0&id=7a9ee883&scoped=true&lang=sass"

import exportComponent from "/home/runner/work/robocleaner/robocleaner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a9ee883"]])

export default __exports__